export const TypographyHeadings = `
<div>
  <h1>H1 Heading</h1>
  <h2>H2 Heading</h2>
  <h3>H3 Heading</h3>
  <h4>H4 Heading</h4>
  <h5>H5 Heading</h5>
  <h6>H6 Heading</h6>
</div>
    `

export const TypographyDisplayHeadings = `
<div>
  <h1 className="display-1">Display 1</h1>
  <h2 className="display-2">Display 2</h2>
  <h3 className="display-3">Display 3</h3>
</div>
  `

export const TypographyTextStyles = `
<div>
  <p class="lead-text">Lead Text / Open Sans Regular</p>
  <p class="body-text">Body / Open Sans Regular</p>
  <p class="card-text">Card Text / Open Sans Regular</p>
  <p class="card-text-2">Card Text 2 / Open Sans Semi-Bold</p>
  <p class="card-subtitle-1">Card Subtitle 1 / Open Sans Regular</p>
  <p class="card-subtitle-2">Card Subtitle 2 / Open Sans Bold</p>
  <p class="form-labels card-caption">
    Form Labels + Card Caption / Open Sans Regular
  </p>
</div>
  `
